import React, { useState, useEffect } from 'react';
import { forwardRef, useRef, useImperativeHandle } from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

const Toast = forwardRef((props, ref) => {
    const [message, setMessage] = useState('');
    useImperativeHandle(
        ref,
        () => ({
            addToast(msg, autoCloseAfterXMilliseconds = 0) {
                setMessage(msg);
                if (autoCloseAfterXMilliseconds > 0) {
                    setTimeout(function () { setMessage(''); }, autoCloseAfterXMilliseconds);
                }
            }
        }),
    )

    return (message && message != '') ? (
        <div className="toast">{ReactHtmlParser(message)}<a className="close" onClick={() => setMessage('')}>⨉</a></div>
    ) : null;
});

export default Toast;




